import { render, staticRenderFns } from "./_DocumentScannerCardModal.vue?vue&type=template&id=18f2dfa6&scoped=true&"
import script from "./_DocumentScannerCardModal.vue?vue&type=script&lang=js&"
export * from "./_DocumentScannerCardModal.vue?vue&type=script&lang=js&"
import style0 from "./_DocumentScannerCardModal.vue?vue&type=style&index=0&id=18f2dfa6&prod&lang=scss&scoped=true&"
import style1 from "./_DocumentScannerCardModal.vue?vue&type=style&index=1&id=18f2dfa6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18f2dfa6",
  null
  
)

export default component.exports